import { getInfoApi, googleLoginApi, logout } from '@/apis/login';
import {remindContent} from '@/apis/common.js'

let getInfoRequest = null;

const getCachedUserInfo = () => {
  const cachedInfo = localStorage.getItem('userInfo');

  if (!cachedInfo) {
    return null;
  }

  try {
    return JSON.parse(cachedInfo);
  } catch (error) {
    localStorage.removeItem('userInfo');
    return null;
  }
};

const user = {
  namespaced: true,
  state: {
    userInfo: getCachedUserInfo(),
    userInfoInitialized: false,
      token: '' || localStorage.getItem('token'),
    userMessage:[]
  },
  mutations: {
    TOKEN(state, token) {
      state.token = token;
            localStorage.setItem('token', token);
    },
    USER_INFO(state, info) {
      state.userInfo = info;
      state.userInfoInitialized = true;
      localStorage.setItem('userInfo', JSON.stringify(info));
      },
      USER_MESSAGE(state, info) {
        state.userMessage=info
      },
      CHANGE_MESSAGE_TYPE(state, info) {
        state.userMessage.forEach(el => {
            if (el.id == info) {
                // el.isRead==1?el.isRead=2:el.isRead=1
                el.isRead=1
            }
        });
      }
  },
  actions: {
    saveToken({ commit }, data) {
      commit('TOKEN', data);
    },

    saveUserInfo({ commit }, data) {
      commit('USER_INFO', data);
    },

    //google快捷登录
    googleLogin({ commit, state }) {
      return new Promise((resolve, reject) => {
        googleLoginApi(state.credential)
          .then((response) => {
            // const { user } = response
            // commit('USER_INFO', user)
            // resolve(user)
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
//获取小铃铛信息
      getRemindContent({ commit, state }) {
          return new Promise((resolve, reject) => {
              const userId = state.userInfo?.user?.userId;
              if (!userId) {
                  return reject('无 userId');
              }

              remindContent({ userId })
                  .then(res => {
                      commit('USER_MESSAGE', res.data);
                      resolve(res.data); // ✅ 关键：resolve 正常返回
                  })
                  .catch(err => {
                      reject(err); // ✅ 有错误时 reject
                  });
          });
      },
    //用户信息(现在绑定了一条获取用户提醒的接口,这个接口不需要强制同步)
    getInfo({ commit }) {
      if (getInfoRequest) {
        return getInfoRequest;
      }

      getInfoRequest = getInfoApi()
        .then((response) => {
          commit('USER_INFO', response);

          const userId = response?.user?.userId;
          if (userId) {
            remindContent({ userId })
              .then(res => commit('USER_MESSAGE', res.data))
              .catch(error => console.warn('[user] getRemindContent failed:', error));
          }

          return response;
        })
        .finally(() => {
          getInfoRequest = null;
        });

      return getInfoRequest;
    },

    // 退出登录
    logout({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout({ Authorization: state.token })
          .then(() => {
              commit('RESET_STATE');
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    }
  }
};
export default user;
